import styled from 'styled-components';
import { InputLabel } from './input-label';
import { Input, InputsRow } from './input';
import { TextArea } from './text-area';
import { HelpText } from './help-text';
import { FieldLabel } from './field-label';
import React from 'react';
import { ErrorBlock } from './error-block';
import { withCssSelector } from '../shared/withCssSelector';
import { Dropdown } from '../dropdown';
import { DateTimeControl } from '../range-date-picker/DateRangePicker.styled';
import { MultiSelectInput } from './multiSelectInput';

const StyledFormField = styled.div`
	display: flex;
	flex-direction: column;

	& + & {
		margin-top: 20px;
	}
	
	
	& > ${TextArea.cssSelector} + ${ErrorBlock.cssSelector},
	& > ${Input.cssSelector} + ${ErrorBlock.cssSelector} {
		margin-top: 4px;
	}

	& > ${FieldLabel.cssSelector} + ${DateTimeControl},
	& > ${FieldLabel.cssSelector} + ${InputLabel.cssSelector},
	& > ${FieldLabel.cssSelector} + ${Dropdown.cssSelector},
	& > ${FieldLabel.cssSelector} + ${Input.cssSelector},
	& > ${FieldLabel.cssSelector} + ${TextArea.cssSelector},
	& > ${FieldLabel.cssSelector} + ${InputsRow},
	& > ${FieldLabel.cssSelector} + ${MultiSelectInput.cssSelector},
	& > ${Input.cssSelector} + ${HelpText.cssSelector},
	& > ${InputLabel.cssSelector} + ${InputLabel.cssSelector},
	& > ${InputLabel.cssSelector} + ${HelpText.cssSelector},
	& > ${TextArea.cssSelector} + ${HelpText.cssSelector},
	& > ${HelpText.cssSelector} + ${Dropdown.cssSelector},
	& > ${HelpText.cssSelector} + ${InputLabel.cssSelector},
	& > ${HelpText.cssSelector} + ${Input.cssSelector},
	& > ${HelpText.cssSelector} + ${TextArea.cssSelector},
	& > ${HelpText.cssSelector} + ${InputsRow},
	& > ${ErrorBlock.cssSelector} + ${TextArea.cssSelector},
	& > ${ErrorBlock.cssSelector} + ${Input.cssSelector} {
		margin-top: 8px;
	}

`;

export type FormFieldProps = React.ComponentPropsWithoutRef<'div'>

export const FormField = withCssSelector(React.forwardRef<HTMLDivElement, FormFieldProps>(
	function FormField(props, ref) {
		return <StyledFormField ref={ref}{...props} />;
	}
), StyledFormField.toString());
